import { BuildPlatform } from "../../../core_stores/useProjectBuildsStore";

export default function ProjectPublishAvailablePlatforms({
  allPlatforms,
  selectedPlatform,
  onPlatformSelected,
}: {
  allPlatforms: {
    type: BuildPlatform;
    label: string;
    icon: React.ReactNode;
    enabled: boolean;
  }[];
  selectedPlatform: BuildPlatform | null;
  onPlatformSelected: (platformType: BuildPlatform) => void;
}) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {allPlatforms.map((platform) => (
        <div key={platform.type} className="relative">
          <button
            onClick={() =>
              platform.enabled && onPlatformSelected(platform.type)
            }
            disabled={!platform.enabled}
            className={`w-full h-24 flex flex-col items-center 
                  justify-center gap-2 p-3 rounded-xl transition-colors duration-300
                  disabled:opacity-100
                  ${
                    selectedPlatform === platform.type
                      ? "bg-white dark:bg-[#272829]"
                      : "bg-[#B4B7CC] dark:bg-[#191C1F] text-white dark:text-dark-text hover:text-light-text hover:bg-white dark:hover:bg-[#272829]"
                  } ${
              !platform.enabled ? "opacity-100 cursor-not-allowed" : ""
            }`}
          >
            {platform.icon}
            <span className="font-medium">{platform.label}</span>
          </button>
          {!platform.enabled && (
            <div
              className="absolute -top-2 -right-2 text-xs px-2 py-1 rounded-full
                bg-[#B4B7CC] dark:bg-[#191C1F] text-white dark:text-dark-text"
            >
              Soon
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
